import http from '@/utils/http.js' // 引入封装的request.js文件
import common from '@/config/common.js'


// 查询我的证书列表
export function queryCertificateList(data) {
    return http.request({
        url: common.url + '/papi/certificate/list',
        method: 'get',
        params: data
    })
}

